export default __webpack_public_path__ + "508762728b57c3526c0f7bc305334a06.jpg";